<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="likeName"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button v-if="$store.getters.isAdmin" no="initData" type="primary" @click="initData">
          {{ $t('CargoMsg.Cargo_InitData') }}
        </el-button>
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{
          $t('common.btn.query')
        }}
        </el-button>
        <el-button no="add" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="update" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="101360-agGrid"
        config-module="101360"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        :total="total"
        no="101360-pagination"
        config-module="101360"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="490px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <!--          <el-form-item :label="$t('CargoMsg.Cargo_DisplayOrder')">-->
          <!--            <el-input-number-->
          <!--                v-model="editDialog.form.serialNum"-->
          <!--                :min="0"-->
          <!--                :max="999"-->
          <!--                controls-position="right"-->
          <!--                @change="serialNumberCharge"-->
          <!--            />-->
          <!--          </el-form-item>-->
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_Code') }}</span>
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_ChineseName') }}</span>
            <el-input v-model="editDialog.form.chineseName" no="chineseName" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_EnglishName') }}</span>
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-form-item>
            <span slot="label">{{ $t('CargoMsg.Cargo_ServiceType') }}</span>
            <el-checkbox-group v-model="checkServiceTypeList" no="serviceType" @change="serviceTypeChange">
              <el-checkbox :label="0" style="float:left">{{ $t('CargoMsg.Cargo_POL') }}</el-checkbox>
              <el-checkbox :label="1" style="float:left">{{ $t('CargoMsg.Cargo_POD') }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import {
  addCustomsMode,
  deleteCustomsMode,
  initCustomsMode,
  listCustomsMode,
  updateCustomsMode
} from '@/api/basicData/customsMode'

export default {
  name: 'CustomsMode',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        // {
        //   headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
        //   field: 'serialNum',
        //   width: 150
        // },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'code',
          width: 150
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ServiceType'),
          field: 'serviceType',
          width: 200,
          valueFormatter: (params) => {
            return this.serviceTypeColumnsLable(params.value)
          }
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNum: -1,
          code: '',
          chineseName: '',
          englishName: '',
          serviceType: -1
        }
      },
      checkServiceTypeList: []
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  methods: {
    onShow() {
      if (!this.rowData) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      listCustomsMode(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          serialNum: 0,
          code: '',
          chineseName: '',
          englishName: '',
          serviceType: 2
        }
        this.checkServiceTypeList = [0, 1]
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_CustomsMode')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        if (rows.length > 1) {
          this.$message.warning(this.$t('common.tips.hasOneOnly'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        if (this.editDialog.form.serviceType === 2) {
          this.checkServiceTypeList = [0, 1]
        } else {
          this.checkServiceTypeList = [this.editDialog.form.serviceType]
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_CustomsMode')
      }
      this.editDialog.visible = true
    },
    // 保存公用-新增修改
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.codeCheck'))
        return
      }
      if (!form.chineseName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.chineseNameCheck'))
        return
      }
      if (!form.englishName) {
        self.$message.warning(self.$t('baseInfo.basicData.chargeUnit.englishNameCheck'))
        return
      }
      const loading = getLoading()
      if (!form.uuid) {
        self.filter.pageNum = 1
        addCustomsMode(form).then(res => {
          self.filter.pageNum = 1
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          self.editDialog.visible = false
        }).finally(() => loading.close())
      } else {
        updateCustomsMode(form).then(res => {
          self.toQuery()
          self.editDialog.visible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }).catch(() => {
          self.editDialog.visible = false
        }).finally(() => loading.close())
      }
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('common.tips.confirmDelete'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        const uuids = Array.from(rows, p => p.uuid)
        deleteCustomsMode(uuids).then(res => {
          self.$message.success(self.$t('common.tips.deleteSuccess'))
          self.filter.pageNum = 1
          self.toQuery()
        }).catch(() => {
        }).finally(() => loading.close())
      }).catch(() => { })
    },
    initData() {
      if (this.total > 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotInitData'))
        return
      }
      const loading = getLoading()
      initCustomsMode().then(res => {
        if (res.data && Number(res.data) > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_InitData') + this.$t('CargoMsg.Cargo_Success'))
        }
        this.filter.pageNum = 1
        this.toQuery()
      }).catch(() => {
      }).finally(() => loading.close())
    },
    serialNumberCharge() {
      this.editDialog.form.serialNum = this.editDialog.form.serialNum ? Math.round(this.editDialog.form.serialNum) : '0'
    },
    serviceTypeChange() {
      if (this.checkServiceTypeList.length > 1) {
        this.editDialog.form.serviceType = 2
      } else {
        this.editDialog.form.serviceType = this.checkServiceTypeList.length > 0 ? this.checkServiceTypeList[0] : -1
      }
    },
    serviceTypeColumnsLable(value) {
      if (value === 0) {
        return this.$t('CargoMsg.Cargo_POL')
      } else if (value === 1) {
        return this.$t('CargoMsg.Cargo_POD')
      } else if (value === 2) {
        return this.$t('CargoMsg.Cargo_POL') + ',' + this.$t('CargoMsg.Cargo_POD')
      } else {
        return ''
      }
    }
  }
}
</script>

